/* eslint-disable react/prop-types */
import { forwardRef, ReactElement } from 'react';
import { MdClose, MdMenuOpen } from 'react-icons/md';
import { IconButton, IconButtonProps } from '@mui/material';

export interface IconButtonForMenuProps extends Omit<IconButtonProps, 'color' | 'size' | 'children'> {
  icon?: ReactElement;
  menuOpen: boolean;
}

export const IconButtonForMenu = forwardRef<HTMLButtonElement, IconButtonForMenuProps>(
  function IconButtonForMenu(props, ref) {
    const { icon, menuOpen, ...rest } = props;
    return (
      <IconButton
        ref={ref}
        {...rest}
        sx={{
          bgcolor: menuOpen ? 'action.selected' : 'background.paper',
          border: '1px solid',
          borderColor: 'outlinedBorder',
          height: 48,
          width: 48,
          ...rest.sx,
        }}
      >
        {menuOpen ? <MdClose /> : icon || <MdMenuOpen />}
      </IconButton>
    );
  }
);
